export default class SideAlertModel {
  text: string;
  timeout: number;
  color: string;

  constructor(text: string, color = "primary", timeout = 3000) {
    this.text = text;
    this.color = color;
    this.timeout = timeout;
  }
}
